import { jsPDF } from "jspdf";
import { img1, img2 } from "../components/images.js";
import { setDate } from "./helpers.js";

export const buildDoc = (state, pulledReqnum) => {
	// Always create a new instance
	const doc = new jsPDF();

	const typeOfExam =
		String(state.program) === "1" || String(state.program) === "2" ? "multipleChoice" : "assign2";

	const reqnum = pulledReqnum ? pulledReqnum : state.reqnum ? state.reqnum : "N/A";

	// Process notes for printing
	let notesPrint = "";
	if (state.notes && state.notes !== "") {
		if (state.notes.length > 46) {
			if (state.notes.length > 330) {
				notesPrint = state.notes.substring(0, 250) + "...";
				notesPrint = notesPrint.replace(/(.{46})/g, "$1\n");
			} else {
				notesPrint = state.notes.replace(/(.{46})/g, "$1\n");
			}
		} else {
			notesPrint = state.notes;
		}
	}

	if (typeOfExam === "multipleChoice") {
		const typeOfExamPrint =
			String(state.program) === "2" ? "Multiple Response Scoring" : "Standard Multiple Choice";
		// Example images and text placement for these types
		doc.addImage(img2, "PNG", 80, 263, 48, 13);
		doc.addImage(img1, "PNG", 10, 5, 25, 25);
		doc.setDrawColor("#275d38");
		doc.setFont(undefined, "bold");
		doc.text("Requisition number: " + reqnum, 65, 32);
		doc.setFont(undefined, "normal");

		doc.rect(8, 37, doc.internal.pageSize.width - 16, 78);
		doc.text("Request Date: " + setDate(), 15, 47);
		const instructorName = state.instructorName
			? state.instructorName
			: state.instructor_name
				? state.instructor_name
				: "N/A";
		doc.text("Client Name: " + instructorName, 15, 57);
		if (state.email2 && state.email2 !== "") {
			doc.text("Emails: " + state.email1.toString() + ", " + state.email2.toString(), 15, 67);
		} else {
			doc.text("Email: " + state.email1.toString(), 15, 67);
		}
		//doc.text("Phone: " + state.phone.toString(), 15, 77);
		const department = state.department ? state.department : state.caddr2 ? state.caddr2 : "N/A";
		doc.text("Department: " + department, 15, 77);

		doc.text("Program: " + typeOfExamPrint, 15, 87);
		doc.text("Delivery: " + state.delivery, 15, 97);
		if (state.delivery !== "Courier" && state.delivery !== "Pick Up") {
			const substringAddress =
				state.address?.length > 0
					? state.address?.substring(0, 32)
					: state.caddr3?.length > 0
						? state.caddr3?.substring(0, 32)
						: "Department Office";
			doc.text("Address: " + substringAddress, 15, 107);
		}

		doc.rect(8, 115, doc.internal.pageSize.width - 16, 60);
		const numberOfQuestions =
			state.hqNum && state.lqNum ? state.hqNum - state.lqNum + 1 : state.hqnum - state.lqnum + 1;
		doc.text("Number of questions: " + numberOfQuestions, 15, 126);
		const numberOfAnswers = state.qLen ? state.qLen : state.qlen ? state.qlen : "N/A";
		doc.text("Number of answers per question: " + numberOfAnswers, 15, 136);
		const numberOfKeys = state.nKeys ? state.nKeys : state.nkeys ? state.nkeys : "N/A";
		doc.text("Number of answer keys: " + numberOfKeys, 15, 146);
		let finalCourseTitle = "";
		const courseTitle = state.courseTitle
			? state.courseTitle
			: state.coursetitle
				? state.coursetitle
				: "N/A";
		if (state.class_ids && Array.isArray(state.class_ids) && state.class_ids.length > 1) {
			finalCourseTitle = courseTitle + " (Multiple Classes)";
		} else {
			finalCourseTitle = courseTitle;
		}
		doc.text("Class: " + finalCourseTitle.substring(0, 16), 15, 156);
		const listOfClassIds = Array.isArray(state.class_ids)
			? state.class_ids.join(",")
			: String(state.class_ids);

		const listOfCombineIds = Array.isArray(state.combineIds)
			? state.combineIds.join(",")
			: String(state.combineIds);

		const classNum =
			listOfCombineIds && listOfCombineIds.length > 0 && listOfCombineIds !== "undefined"
				? listOfClassIds + "," + listOfCombineIds
				: listOfClassIds && listOfClassIds.length > 0 && listOfClassIds !== "undefined"
					? listOfClassIds
					: state.class_ids && state.class_ids.length > 0
						? state.class_ids
						: "N/A";

		if (classNum && classNum === "N/A") {
			let tempId = "";
			if (state.class_ids) {
				tempId = state.class_ids;
			}
			doc.text("ID(s): " + tempId, 15, 166);
		} else {
			doc.text("ID(s): " + classNum, 15, 166);
		}

		doc.rect(8, 175, doc.internal.pageSize.width - 16, 50);
		notesPrint.length > 100 ? doc.setFontSize(10) : doc.setFontSize(16);
		doc.text("Notes: " + notesPrint, 15, 185);
		doc.setFontSize(16);

		doc.rect(8, 225, doc.internal.pageSize.width - 16, 35);
		doc.text("If you have any questions or require assistance, please contact TSS", 15, 238);
		doc.text("by emailing opscan@ualberta.ca or by calling 780.492.2741.", 25, 248);
	} else if (typeOfExam === "assign2") {
		// Build the receipt for an Assign2 exam
		doc.addImage(img2, "PNG", 80, 255, 50, 14);
		doc.addImage(img1, "PNG", 10, 3, 25, 25);
		doc.setDrawColor("#275d38");
		doc.setFont(undefined, "bold");
		doc.text("Requisition number: " + reqnum, 68, 27);
		doc.setFont(undefined, "normal");

		doc.rect(8, 32, doc.internal.pageSize.width - 16, 83);
		doc.text("Request Date: " + setDate(), 30, 45);
		doc.text("Client Name: " + state.instructorName, 30, 55);
		doc.text("Email: " + state.email1, 30, 65);
		doc.text("Phone: " + state.phone, 30, 75);
		const department = state.department ? state.department : state.caddr2 ? state.caddr2 : "N/A";
		doc.text("Department: " + department, 30, 85);
		doc.text("Delivery: " + state.delivery, 30, 95);
		if (state.delivery !== "Courier" && state.delivery !== "Pick Up") {
			const substringAddress =
				state.address?.length > 0
					? state.address.substring(0, 32)
					: state.caddr3?.length > 0
						? state.caddr3.substring(0, 32)
						: "Department Office";
			doc.text("Address: " + substringAddress, 30, 107);
		}
		doc.rect(8, 115, doc.internal.pageSize.width - 16, 75);
		doc.text("Number of booklets: " + state.booklets, 30, 128);
		doc.text("Number of pages per booklet: " + state.sheets, 30, 138);
		doc.text("Sided: " + state.sided, 30, 148);
		if (state.tsqs_upload === "upload") {
			doc.text("Upload: TSS will load the exam. Please add one of us as", 30, 158);
			doc.text("an instructor.", 30, 168);
		}
		if (state.tsqs_upload === "doNotUpload") {
			doc.text("Send: TSS will email you the scanned .pdf files once", 30, 158);
			doc.text("the upload has finished", 30, 163);
		}
		doc.text("Class: " + state.courseTitle?.substring(0, 16), 30, 178);
		doc.rect(8, 190, doc.internal.pageSize.width - 16, 60);
		doc.text("If you have any questions or require assistance, please contact TSS", 15, 213);
		doc.text("by emailing opscan@ualberta.ca or by calling 780.492.2741.", 25, 223);
	}
	return doc;
};
